exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".kUemLs7xWDg0RyAr8UQ-R ._2MnyFLNn3X25a1c_VYnnqT{min-width:0;min-height:0;margin:0;padding:0;position:absolute;outline:none !important;resize:none;border:none;overflow:hidden;color:transparent;background-color:transparent}.kUemLs7xWDg0RyAr8UQ-R ._2MnyFLNn3X25a1c_VYnnqT._2Z6JS_m8DqgzAg8Zsftm6-{z-index:10}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "kUemLs7xWDg0RyAr8UQ-R",
	"inputarea": "_2MnyFLNn3X25a1c_VYnnqT",
	"ime-input": "_2Z6JS_m8DqgzAg8Zsftm6-"
};